import { render, staticRenderFns } from "./MyIdeas.vue?vue&type=template&id=c60f01e8&"
import script from "./MyIdeas.vue?vue&type=script&lang=js&"
export * from "./MyIdeas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports